<template>
  <!-- 页面框架总体布局组件 -->
  <div class="app-container">
    <div class="app-main">
      <div class="navbar-wrap">
        <div class="navbar-main clearfix">
          <div class="navbar-logo" @click="toHome">
            <img src="/static/image/logo3.png" />
          </div>
          <div class="navbar-info">
            <span>学习时长：{{$store.state.userStudyProgress.studyDuration || 0}}</span>
            <span>学习进度：{{$store.state.userStudyProgress.studyProgress}}（{{$store.state.userStudyProgress.studyNum}}/{{$store.state.userStudyProgress.videoNum}}）</span>
            <span class="cursor-p" @click="toUserCenter">
              <img class="user-img" src="/static/image/user.png" />
              {{$store.state.userInfo.nickName || $store.state.userInfo.accessName}}
            </span>
            <span
              v-if="$store.state.userInfo.accessName === $store.state.manageAccessName"
              class="cursor-p"
              @click="handleManage"
            >统计管理</span>
            <span class="cursor-p" @click="handleLogout">退出登录</span>
          </div>
        </div>
      </div>
      <el-main class="content">
        <el-row>
          <el-col :span="24">
            <router-view>路由视图</router-view>
          </el-col>
        </el-row>
      </el-main>
    </div>
  </div>
</template>

<script>
import { removeToken } from '@/utils/auth' // token处理
import api from '@/api' // api

export default {
  data () {
    return {
      studyDuration: 0, // 学习总时长
      studyNum: 0, // 已学习完成视频总数
      videoNum: 0, // 视频总数
      studyProgress: 0 // 学习完成视频进度
    }
  },
  components: {

  },
  methods: {
    /**
     * 跳抓到首页
     **/
    toHome () {
      if (this.$route.path !== '/study/list') {
        this.$router.push('/study/list')
      }
    },
    /**
     * 跳转到个人中心页面
     **/
    toUserCenter () {
      if (this.$route.path !== '/user/base') {
        this.$router.push('/user/base')
      }
    },
    /**
     * 退出登录
     **/
    handleLogout () {
      // 退出登录时在前端清除token，然后跳转到登录页
      removeToken()
      // 将通过了管理验证状态保存在vuex store移除
      // this.$store.commit('UPDATE_MANAGE_PASS', false)
      this.$router.push('/login')
    },
    /**
     * 获取用户信息
     **/
    getUserInfo () {
      api.getUserInfo.r().then((res) => {
        const userInfo = res.data.data
        this.$store.commit('UPDATE_USER_INFO', userInfo)
      })
    },
    /**
     * 管理
     * @description 管理查看所有用户的学习情况
     * @description 已通过管理验证后，再次点击管理按钮，不需要验证直接跳转到统计页面
     * @description 显示输入管理密码弹窗，验证管理密码后，将管理密码已验证通过对状态储存在vuex store中，然后跳转到统计页面
     **/
    handleManage () {
      if (this.$store.state.userInfo.accessName === this.$store.state.manageAccessName) {
        // 跳转到统计页面
        if (this.$route.path !== '/admin/statistic') {
          this.$router.push('/admin/statistic')
        }
      }
      // this.$prompt('请输入管理密码', '管理验证', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputType: 'password',
      //   closeOnClickModal: false,
      //   inputPattern: /[0-9a-zA-Z]/,
      //   inputErrorMessage: '管理密码错误'
      // }).then(({ value }) => {
      //   let pwd = 'dGpseDIwMTkxMjM='
      //   // 编码密码
      //   let utf8Pwd = CryptoJS.enc.Utf8.parse(value)
      //   let base64Pwd = CryptoJS.enc.Base64.stringify(utf8Pwd)
      //   if (pwd !== base64Pwd) {
      //     this.$message({
      //       type: 'error',
      //       message: '管理密码错误！'
      //     })
      //     return
      //   }
      //   // 将通过了管理验证状态保存在vuex store中
      //   this.$store.commit('UPDATE_MANAGE_PASS', true)
      //   // 跳转到统计页面
      //   if (this.$route.path !== '/admin/statistic') {
      //     this.$router.push('/admin/statistic')
      //   }
      // }).catch(() => { })
    }
  },
  created () {
    // 获取用户信息
    this.getUserInfo()
    // 获取用户学习进度,调用vuex store 方法
    this.$store.dispatch('getUserStudyProgress')
  }
}
</script>

<style scoped>
.navbar-wrap {
  box-sizing: border-box;
  height: 70px;
  padding: 15px 0;
  background-color: #c70019;
}
.navbar-main {
  width: 1200px;
  margin: 0 auto;
}
.navbar-logo {
  float: left;
  cursor: pointer;
}
.navbar-info {
  float: right;
  color: #fff;
  line-height: 40px;
}
.navbar-info span + span:before {
  content: "/";
  margin-left: 13px;
  margin-right: 15px;
}
.user-img {
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
}
.content {
  padding: 0;
}
.main-footer {
  padding: 30px 0 26px;
  background-color: #333333;
}
.main-footer-main {
  width: 1200px;
  margin: 0 auto;
  color: #f3f3f3;
  line-height: 24px;
}
.manager-login-btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue